// assets
import { IconUserCheck, IconBasket, IconMessages, IconLayoutKanban, IconMail, IconCalendar, IconNfc } from '@tabler/icons';

import StorageIcon from '@mui/icons-material/Storage';

// constant
const icons = {
    IconUserCheck,
    IconBasket,
    IconMessages,
    IconLayoutKanban,
    IconMail,
    IconCalendar,
    IconNfc
};

const icoMenu = {
    StorageIcon
}

const databases = {
    id: 'databases',
    title: '',
    type: 'group',
    children: [
        {
            id: 'databases_menu',
            title: 'Operaciones base datos',
            type: 'collapse',
            icon: icoMenu.StorageIcon,
            children: [                
                {
                    id: 'encerar_database',
                    title: 'Limpiar Base datos',
                    type: 'item',
                    url: '/user/encerar-database',
                    superOnly: true
                },
                {
                    id: 'migration_inventarios',
                    title: 'Migración Inventarios',
                    type: 'item',
                    url: '/user/migration-database-inventarios',
                    superOnly: true
                },
                {
                    id: 'migration_cuentas_pagar_proveedores',
                    title: 'Migración Cuentas Pagar Proveedores',
                    type: 'item',
                    url: '/user/migration-database-cuentas-pagar-proveedores',
                    superOnly: true
                },
                {
                    id: 'migration_cuentas_cobrar_clientes',
                    title: 'Migración Cuentas Cobrar Clientes',
                    type: 'item',
                    url: '/user/migration-database-cuentas-cobrar-clientes',
                    superOnly: true
                },
                {
                    id: 'migration_estado_situacion_inicial',
                    title: 'Migración Estado Situación Inicial',
                    type: 'item',
                    url: '/user/migration-database-estado-situacion-inicial',
                    superOnly: true
                },
                {
                    id: 'respaldo_base_datos',
                    title: 'Respaldo Base datos',
                    type: 'item',
                    url: '/user/respaldo-base-datos',
                    hideForSuper: true
                },
            ]
        },
        {
            id: 'zonas',
            title: 'Zonas',
            type: 'item',
            icon: icoMenu.StorageIcon,
            url: '/user/zonas'
        },
    ]
};

export default databases;
